/**
 * 动态插入css
 */
export const loadStyle = url => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}

export function uuid () {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substr(uuid.lastIndexOf('/') + 1)
}

/**
 * 输入示例：
 *
 * const data = [
 *   { id: '2026050801', price: 100 },
 *   { id: '2026050802', price: 200 },
 *   { id: '2026050901', price: 150 },
 * ]
 * groupByTimePrefix(data, 'id', 'price')
 *
 * 输出：
 *
 * {
 *   '20260508': [100, 200],
 *   '20260509': [150]
 * }
 */
export function groupByTimePrefix(array, idField, priceField) {
  return array.reduce((acc, item) => {
    // 提取 idField 的前 8 位作为分组键
    const groupKey = String(item[idField]).substring(0, 8);

    // 如果分组键不存在，初始化为一个空数组
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }

    let itemElement = item[priceField];
    // 将 priceField 加入相应的分组数组
    acc[groupKey].push(itemElement === undefined ? 0 : itemElement);

    return acc;
  }, {});
}

